import { API } from '../../apis/limeAuthUtils/apiWrapper';
import { getCurrentAuthUserEmail } from '../../lib/utils';

export async function fetchAssets() {
    /**
     * function to list all ddf assets
     */
    const apiName = 'v1/asset-management';
    const requester = await getCurrentAuthUserEmail();
    const myInit = {
        queryStringParameters: {
            requester: requester,
        },
    };
    return await API.get(apiName, '/v1/assets', myInit);
}

export async function deleteAsset(id) {
    /**
     * function to call api to delete asset for current user
     * @param id: string
     */
    const apiName = 'v1/asset-management';
    const myInit = {
        queryStringParameters: {
            id: id,
        },
    };
    return await API.del(apiName, '/v1/assets', myInit);
}
